import React, { useContext } from "react";
import { AuthContext } from "../../../context/AuthContext";

const AdminInfoPage = () => {
  const { currentUser } = useContext(AuthContext);

  // Affichage uniquement si l'utilisateur est connecté ET admin
  if (!currentUser || currentUser.profile?.role !== "admin") {
    return (
      <div style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
      }}>
        <div style={{
          background: "white",
          borderRadius: 16,
          padding: 32,
          boxShadow: "0 4px 24px rgba(0,0,0,0.08)",
          color: "#c0392b",
          fontWeight: 600
        }}>
          Accès réservé aux administrateurs.
        </div>
      </div>
    );
  }

  // Récupération des infos
  const { first_name, last_name, email } = currentUser;
  const role = currentUser.profile?.role || "";

  return (
    <div style={{
      minHeight: "100vh",
      background: "linear-gradient(135deg, #eaf0fa 0%, #d8e0f2 100%)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    }}>
      <div style={{
        background: "white",
        borderRadius: 20,
        padding: "40px 48px",
        boxShadow: "0 8px 32px rgba(58,70,104,0.10)",
        minWidth: 380
      }}>
        <h2 style={{ color: "#3a4668", fontWeight: 700, marginBottom: 32 }}>
          Informations Administrateur
        </h2>
        <div style={{ marginBottom: 20 }}>
          <strong>Prénom :</strong> <span style={{ marginLeft: 8 }}>{first_name}</span>
        </div>
        <div style={{ marginBottom: 20 }}>
          <strong>Nom :</strong> <span style={{ marginLeft: 8 }}>{last_name}</span>
        </div>
        <div style={{ marginBottom: 20 }}>
          <strong>Adresse e-mail :</strong> <span style={{ marginLeft: 8 }}>{email}</span>
        </div>
        <div>
          <strong>Rôle :</strong>
          <span style={{
            marginLeft: 8,
            background: "linear-gradient(135deg, #e74c3c 0%, #c0392b 100%)",
            color: "white",
            padding: "4px 16px",
            borderRadius: "12px",
            fontSize: "14px",
            fontWeight: 600,
            textTransform: "uppercase"
          }}>
            {role}
          </span>
        </div>
      </div>
    </div>
  );
};

export default AdminInfoPage;
